<template>
  <div>
    <b-row v-if="checkAccessPrivilege('JeetPrivilege.Cashback.BotLog')">
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col sm="3">
                <label class="mx-sm-2" for="sType">Cashback For </label>
                <b-form-select id="sType" :plain="true" :options="cashbackType" v-model="sType" text-field="label" value-field="value">
                </b-form-select>
              </b-col>
              <b-col sm="3">
                <label class="mr-sm-2" for="sUsername">Username </label>
                <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
              </b-col>
              <b-col sm="3">
                <label class="mr-sm-2" for="sOrderNumber">Order Number </label>
                <b-input id="sOrderNumber" type="text" placeholder="" v-model.trim="sOrderNumber"></b-input>
              </b-col>
              <b-col sm="3">
                <label class="mx-sm-2" for="sStatus">Status </label>
                <b-form-select id="sStatus" :plain="true" :options="statusList" v-model="sStatus" text-field="label" value-field="value">
                  <template slot="first">
                    <option :value="null">-- Please select an option --</option>
                  </template>
                </b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <label class="mr-sm-2" for="sStartDate">Start Date </label>
                <b-input id="sStartDate" type="date" placeholder="" v-model.trim="sStartDate"></b-input>
              </b-col>
              <b-col sm="3">
                <label class="mr-sm-2" for="sEndDate">End Date </label>
                <b-input id="sEndDate" type="date" placeholder="" v-model.trim="sEndDate"></b-input>
              </b-col>
              <b-col sm="3" class="align-self-end">
                <b-button variant="primary" @click="searchCashbackbackJobLog"><i class="fa fa-search"></i> Search</b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-android'></i> Cashback Job Log</h3>
            <h5 class="float-right" style="margin-left: 10px"> Total Cashback Added: {{format(totalCashback, '0,0.00')}}</h5>
            <b-button variant="primary" class="float-right" @click="exportCSV">Export</b-button>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(sn)="data">
                {{data.index+1 + ((currentPage-1)*perPage)}}
              </template>
              <template v-slot:cell(Status)="data">
                <b-badge variant="info" v-if="data.item.Status === 0">Processing</b-badge>
                <b-badge variant="success" v-if="data.item.Status === 1">Success</b-badge>
                <b-badge variant="danger" v-else-if="data.item.Status === 2">Failed</b-badge>
                <b-badge variant="info" v-else-if="data.item.Status === 3">ManualTransfer</b-badge>
              </template>
              <template v-slot:cell(MarkOperator)="data">
                <template v-if="(data.item.Status===3 || data.item.Status===1) && checkAccessPrivilege('JeetPrivilege.Cashback.BotLog.Mark')">{{ data.item.MarkOperator }}</template>
                <b-button v-else variant="warning" @click="markRecord(data.item.Id)">Mark</b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../../events.js'
  import numeral from 'numeral'
  const moment = require('moment-timezone')
  export default {
    name: 'cashbackjob-log-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        totalCashback: 0,
        items: [],
        fields: [
          {key: 'sn', label: 'S.No'},
          {key: 'Transaction', label: 'TransactionId'},
          {key: 'Username', label: 'Username'},
          {key: 'Amount', label: 'Amount'},
          {key: 'Status', label: 'Status'},
          {key: 'MarkOperator', label: 'MarkOperator'}
        ],
        statusList: [
          { label: 'Processing', value: '0' },
          { label: 'Success', value: '1' },
          { label: 'Failed', value: '2' },
          { label: 'ManualTransfer', value: '3' }
        ],
        cashbackType: [
          { label: 'Masti Monday', value: 'Masti Monday' },
          { label: 'Sports Cashback', value: 'Sports Cashback' }
        ],
        currentPage: 1,
        perPage: 30,
        operator: '',
        sUsername: '',
        sType: 'Masti Monday',
        sOrderNumber: '',
        sStatus: null,
        sStartDate: moment().isoWeekday(1).format('YYYY-MM-DD'),
        sEndDate: moment().isoWeekday(1).format('YYYY-MM-DD')
      }
    },
    methods: {
      format (num, fmt) {
        return numeral(num).format(fmt)
      },
      getRowCount (items) {
        return items.length
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      },
      searchCashbackbackJobLog () {
        this.getAllCashbackJobLog()
      },
      async getAllCashbackJobLog () {
        try {
          let queryStr = `?type=${this.sType}&username=${this.sUsername}&orderNumber=${this.sOrderNumber}&status=${this.sStatus || ''}&startDate=${this.sStartDate}&endDate=${this.sEndDate}`
          let { data } = await this.$http.get(this.API_ENDPOINT + '/jeetprivilege/cashbackbot/getAll' + queryStr, { headers: { 'Content-Type': 'application/json' } })
          this.items = data.result
          this.totalCashback = data.totalCashback
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async exportCSV () {
        try {
          let queryStr = `?type=${this.sType}&username=${this.sUsername}&orderNumber=${this.sOrderNumber}&status=${this.sStatus || ''}&startDate=${this.sStartDate}&endDate=${this.sEndDate}`
          let { data } = await this.$http.get(this.API_ENDPOINT + '/jeetprivilege/cashbackbot/getAll/export' + queryStr, { responseType: 'blob', headers: { 'Content-Type': 'application/json' } })
          let url = window.URL.createObjectURL(new Blob([ data ]))
          let link = document.createElement('a')
          link.href = url
          let fileName = `cashback_job_log_${moment().format('YYYYMMDD')}.csv`
          if (this.sType === 'Sports Cashback') {
            fileName = `sports_cashback_job_log_${moment().format('YYYYMMDD')}.csv`
          }
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async markRecord (id) {
        try {
          await this.$http.post(this.API_ENDPOINT + '/jeetprivilege/cashbackbot/mark', { id: id }, { headers: { 'Content-Type': 'application/json' } })
          Events.$emit('success', VueNotifications.types.success, 'Success', 'Transaction Marked Successfully')
          this.getAllCashbackJobLog()
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      }
    },
    created () {
      this.getAllCashbackJobLog()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/cashback/cashbackJobLog/CashbackJobLogTable.vue